module.exports = "<em>Power resource needed:</em>\n{{ powerNeeded | number }}\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/power-resource-needed.component/power-resource-needed.component.html
// module id = ../../../../../src/app/page-creep-level.module/power-resource-needed.component/power-resource-needed.component.html
// module chunks = main